/** Islamisk geometrisk ornament brugt som dekorativ baggrund. */

export function ornament({ color = '#ef1c21', detailed = false } = {}) {
  const base = `
    <polygon points="200,10 390,200 200,390 10,200" stroke="${color}" stroke-width="1" fill="none"/>
    <polygon points="200,50 350,200 200,350 50,200" stroke="${color}" stroke-width=".8" fill="none"/>
    <circle cx="200" cy="200" r="160" stroke="${color}" stroke-width=".5" fill="none"/>
    <circle cx="200" cy="200" r="110" stroke="${color}" stroke-width=".5" fill="none"/>
    <line x1="200" y1="40" x2="200" y2="360" stroke="${color}" stroke-width=".4"/>
    <line x1="40" y1="200" x2="360" y2="200" stroke="${color}" stroke-width=".4"/>
    <line x1="87" y1="87" x2="313" y2="313" stroke="${color}" stroke-width=".4"/>
    <line x1="313" y1="87" x2="87" y2="313" stroke="${color}" stroke-width=".4"/>`;

  const extra = detailed ? `
    <polygon points="200,80 320,160 320,240 200,320 80,240 80,160" stroke="${color}" stroke-width=".8" fill="none"/>
    <polygon points="200,110 295,170 295,230 200,290 105,230 105,170" stroke="${color}" stroke-width=".8" fill="none"/>
    <polygon points="200,140 270,180 270,220 200,260 130,220 130,180" stroke="${color}" stroke-width=".8" fill="none"/>` : '';

  return `<svg viewBox="0 0 400 400" fill="none" aria-hidden="true">${base}${extra}</svg>`;
}

/** Indsætter ornamenter i alle elementer med [data-ornament] */
export function mountOrnaments(root = document) {
  root.querySelectorAll('[data-ornament]').forEach(el => {
    el.innerHTML = ornament({
      color:    el.dataset.ornamentColor || '#ef1c21',
      detailed: el.dataset.ornament === 'detailed'
    });
  });
}
